import styled from 'styled-components';
import { colors } from '@spa/shared/theme';

export const MarkerContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #fff;
  font-family: IntervalNextReg, sans-serif;
  cursor: pointer;
  padding: 6px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #224251;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);

  &.marker--clicked {
    background: ${colors.paleGray};
  }

  &.marker--active,
  &.marker--active--hover {
    background-color: #224251;
    color: #fff;

    span {
      background-color: #fff;
      color: #224251;
    }
  }

  span {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 20px;
    height: 20px;
    background-color: #224251;
    color: #fff;
    text-align: center;
    font-family: IntervalNextReg, sans-serif;
    font-weight: 600;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    border-radius: 10px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  }

  svg {
    display: block;
    margin: auto;
    margin-right: 5px;

    &.wishlist-button {
      &.active {
        > path {
          fill: #f7988b;
        }
      }
    }
  }
`;
